import { selectExplorerTailSize, selectLoadedExplorer } from '../../../domain'

import { ExplorerUsecase } from './Explorer'

export class UpdateExplorerTailUsecase extends ExplorerUsecase {
    updateTailSize (tailSize: number): boolean {
        if (!Number.isInteger(tailSize) || tailSize < 0) {
            return false
        }

        const state = this.getState()
        if (selectExplorerTailSize(state) === tailSize) {
            return false
        }

        this.setExplorer({ tailSize, tail: ExplorerUsecase.createTail(selectLoadedExplorer(state)) })
        return true
    }

    toggleTailing (): void {
        const { isTailing } = selectLoadedExplorer(this.getState())
        this.setExplorer({ isTailing: !isTailing })
    }

    clearTail (): void {
        this.setExplorer({ tail: [] })
    }
}
